import { getLabelFromLink } from './get_label_from_link';

export const getClickedLinkElementLabel = ( level, $linkElement ) =>
    level === 2
        ? $linkElement
            .find('.navigation-level-2-link__label')
            .text()
        : getLabelFromLink($linkElement[0]);
